// DS: DEV8
import React from 'react';
import c from 'classnames';
import DeviationDumbView from '../DeviationViews/Dumbo';
import s from './GallectionCoverDumbo.scss';
const GallectionCoverDumbo = ({ width, height, className, gallection: { thumb }, placeholder, placeholderClassName })=>{
    if (!thumb) {
        return /*#__PURE__*/ React.createElement("div", {
            className: c(className, placeholderClassName || s['no-image']),
            style: {
                width,
                height
            }
        }, placeholder);
    }
    return /*#__PURE__*/ React.createElement(DeviationDumbView, {
        className: className,
        width: width,
        height: height,
        deviation: thumb
    });
};
GallectionCoverDumbo.displayName = 'GallectionCoverDumbo';
export default GallectionCoverDumbo;
